import React from 'react'

const useStateRef = <T>(state: T) => {
  const ref = React.useRef<T>(state)

  React.useEffect(() => {
    if (ref.current) {
      ref.current = state
    }
  }, [state])

  return ref
}

export default useStateRef
